import apiHandler from "../../core/apiHandler";

/**
 * 📊 profileReportApi
 *
 * API central para la gestión de reportes por perfil de cliente.
 * 
 * Agrupa los endpoints relacionados con:
 * - Listado de reportes asociados a un perfil
 * - Activar / desactivar reportes
 * - Listar reportes globales (dropdown)
 *
 * 📦 Ubicación sugerida: src/api/profileReportApi.ts
 * 🧩 Base URL: /api/profile-reports
 */
const profileReportApi = apiHandler("profile-reports");

/**
 * 🔹 Endpoints disponibles:
 * 
 * - GET   /profile/:profileId        → obtener reportes del perfil
 * - PUT   /toggle                    → activar/desactivar reporte
 * - GET   /dropdown                  → listar todos los reportes globales
 */
export default profileReportApi;
